import { TrafficCoverageLevel } from './types';

export const trafficCoverageLevelToShortI18nKeyMap: Record<TrafficCoverageLevel, string> = {
  [TrafficCoverageLevel.VeryLow]: 'common:sampling-widget.traffic-coverage.short.very-low',
  [TrafficCoverageLevel.Low]: 'common:sampling-widget.traffic-coverage.short.low',
  [TrafficCoverageLevel.Medium]: 'common:sampling-widget.traffic-coverage.short.medium',
  [TrafficCoverageLevel.High]: 'common:sampling-widget.traffic-coverage.short.high',
  [TrafficCoverageLevel.Max]: 'common:sampling-widget.traffic-coverage.short.max',
};
